import { TopicPart } from "../../topicPart/entities/TopicPart";

export interface Topic {
  id: string;
  trainingId: string;
  title: string;
  description?: string | null;
  level?: string;
  image?: string | null;
  categoryId?: string | null;
  tags?: string[];
  keywords?: string[];
  introduction?: string;
  synthesis?: string;
  conclusion?: string;
  goals?: string[];
  relatedTopicIds?: string[];
  badgeId?: number | null;
  rank?: number;
  status: "draft" | "available" | "unavailable";
  comments?: string | null;
  topicParts?: TopicPart[];
  created?: string;
  updated?: string;
}

export type TopicFormData =
  & Omit<
    Topic,
    | "id"
    | "rank"
    | "badgeId"
    | "updated"
    | "created"
    | "image"
  >
  & {
    image?: string | File | null;
  };

export const emptyTopic = (trainingId: string): TopicFormData => ({
  title: "",
  description: null,
  trainingId: trainingId,
  categoryId: null,
  image: null,
  status: "draft",
  level: "all",
  relatedTopicIds: [],
  introduction: "",
  tags: [""],
  keywords: [""],
  synthesis: "",
  conclusion: "",
  goals: [""],
  comments: null,
});
